{
  "title": {
    "create": "Crea terreno",
    "edit": "Edita el terreno"
  },
  "name": "Nombre",
  "bounds": "Límites",
  "tiles": "Azulejos",
  "remove_tiles": "Eliminar mosaicos",
  "Pending": "Pendiente",
  "Active": "Activo",
  "Deleted": "Eliminado",
  "terrain_options": "Haga clic para abrir las opciones de terreno",
  "edit": "Edita el terreno",
  "delete": "Eliminar terreno",
  "uploading_tiles": "Subir mosaicos"
}